import uniAdminApi from "./api";

const permissionService = {
  getCatalog: async () => {
    const res = await uniAdminApi.get("/university-admin/permissions/catalog");
    return res.data;
  },

  getGrants: async (adminUserId) => {
    const res = await uniAdminApi.get(`/university-admin/permissions/grants/${adminUserId}`);
    return res.data;
  },

  grant: async ({ adminUserId, httpMethod, pathTemplate }) => {
    const res = await uniAdminApi.post("/university-admin/permissions/grants", {
      adminUserId,
      httpMethod,
      pathTemplate,
    });
    return res.data;
  },

  revoke: async ({ adminUserId, httpMethod, pathTemplate }) => {
    const res = await uniAdminApi.delete("/university-admin/permissions/grants", {
      data: { adminUserId, httpMethod, pathTemplate },
    });
    return res.data;
  },
};

export default permissionService;
